<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'lineChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        }
        // colorArr:{
        //     type: Array | Object,
        //     default: function () {
        //         let colr = 
        //         return colr;
        //     }
        // }
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        barOption(){
            let _this = this;
            var xWidth = (_this.xAxisName=='')?'10':'50';
            var option = {
                legend: {
                    // data: ['HTMLElement', 'WebGL', 'SVG', 'CSS', 'Other']
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '下载',
                        }
                    }
                },
                series: [{
                    type: 'graph',
                    // zoom:.5,
                    layout: 'force',
                    animation: true,
                    roam: true,
                    label: {
                        normal: {
                            position: 'right',
                            formatter: '{b}'
                        }
                    },
                    draggable: true,
                    data: _this.dataArray.nodes.map(function (node, idx) {
                        node.id = idx;
                        return node;
                    }),
                    categories: _this.dataArray.categories,
                    force: {
                        // initLayout: 'circular'
                        // repulsion: 20,
                        edgeLength: 15,
                        repulsion: 30,
                        gravity: 0.2,
                        // layoutAnimation: true
                    },
                    edges: _this.dataArray.links
                }]
            };
            return option;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.barOption());
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/pathChart.vue